import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { take } from 'rxjs/operators';
import { MasterClienteEditarUsuarioComponent } from '../cliente-editar-usuario/cliente-editar-usuario.component';
import { User } from './cliente-visualizar-usuario.model';
import { MasterClienteVisualizarUsuarioService } from './cliente-visualizar-usuario.service';
import { UserStatus } from '@app/shared/models/user-status';

import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';

import { PermissionsType } from '../../../../custom-shared/enums/permissions-type.enum';
import { InvestmentFunds } from '../../visualizar-usuario/master-visualizar-usuario.model';
import { MatPaginator } from '@angular/material/paginator';
@Component({
  selector: 'app-cliente-visualizar-usuario',
  templateUrl: './cliente-visualizar-usuario.component.html',
  styleUrls: ['./cliente-visualizar-usuario.scss'],
})
export class MasterClienteVisualizarUsuarioComponent extends AppScreenBase
  implements OnInit {
  protected onClose(): void {}

  id: any;
  user: User;
  dialogConfig: any;

  fundsColumns = ['code', 'name'];

  @ViewChildren(MatSort) sortFunds = new QueryList<MatSort>();
  @ViewChildren(MatPaginator) paginator= new QueryList<MatPaginator>();

  sortTopProfitability: MatSort;

  panelOpenState = false;

  constructor(
    private userService: MasterClienteVisualizarUsuarioService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MasterClienteVisualizarUsuarioComponent>,
    private customAuthenticationService: CustomAuthenticationService,
  ) {
    super();
  }

  ngOnInit() {
    this.getUser();

    this.dialogConfig = new MatDialogConfig();

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';

  }
  get userInactive(): boolean {
    if (!this.user) return true;
    return (
      this.user.status &&
      this.user.status.toLowerCase() == UserStatus.inativo.toLowerCase()
    );
  }


  get editAccess(): boolean {
    return !this.customAuthenticationService.hasPermission(
      PermissionsType.editarUsuarios,
    );
  }

  getUser() {
    let objectId = `{"id":"${this.id}"}`;

    this.userService.getUserByUserId(this.id).subscribe(response => {
      this.user = response;
      this.user.investmentGroups = response.investmentGroups.naturalSort([
        'name',
      ]);

      if (this.user.nationality.toLocaleLowerCase() == 'residente') {
        this.user.documentNumber = this.user.documentNumber.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/g,
          '$1.$2.$3-$4',
        );
      }

      this.user.internationalPrefix =
        this.user && this.user.internationalPrefix
          ? this.user.internationalPrefix.substr(2, 3)
          : '';

      this.user.cellNumber =
        this.user && this.user.cellNumber
          ? this.user.cellNumber.replace(/(\d{2})(\d{5})(\d{4})/g, '($1)$2-$3')
          : ' ';
    });
  }

  instanceDataSource(arr, index) {
   /*  const dataSource = new MatTableDataSource<InvestmentFunds>(
      arr.naturalSort(['code']),
    );

    dataSource.sortingDataAccessor = (data, sortHeaderId) =>
      data[sortHeaderId].naturalNormalize();
    dataSource.sort = this.sortFunds.toArray()[index];
    dataSource.paginator = this.paginator.toArray()[index] */
    return arr;
  }

  doFechar() {
    this.dialogRef.close();
  }

  editUser() {
    if (this.userInactive) return;
    if (this.editAccess) return;
    this.dialogConfig.data = { id: this.id };
    let editDialog: MatDialogRef<any>;

    editDialog = this.dialog.open(
      MasterClienteEditarUsuarioComponent,
      this.dialogConfig,
    );

    editDialog
      .afterClosed()
      .pipe(take(1))
      .subscribe(result => {
        this.getUser();
        this.dialogConfig.data = null;
      });
  }
}
